<template>
  <div>
    <naj-box :title="local.bankruptcy.subRequests.requestDetails">
      <!-- Audit Center Notes -->
      <div v-if="formModel.incompleteReasons && formModel.incompleteReasons.length">
        <v-row>
          <v-col cols="12">
            <naj-alert type="error">
              <template slot="content">
                <div class="requestAuditCenterNotes">
                  {{ local.bankruptcy.subRequests.requestAuditCenterNotes }}
                </div>
                <div
                  v-for="(note, index) in formModel.incompleteReasons"
                  :key="index"
                >
                  <div v-if="note">
                    - {{ note }}
                  </div>
                </div>
              </template>
            </naj-alert>
          </v-col>
        </v-row>
      </div>

      <!-- Dynamic Form -->
      <div v-if="useDynamicForm">
        <dynamic-form
          :form-id="formModel.formId"
          :required-data="requiredData"
          :form-model="requestDataJson"
          :root-form-model="formModel"
          :view-mode="viewMode"
          @formChanged="dynamicFormChanged"
        ></dynamic-form>
      </div>

      <!-- Default Form -->
      <div v-else>
        <v-row>
          <v-col cols="12">
            <naj-input
              :type-id="formFieldType.textarea"
              :label="local.bankruptcy.subRequests.requestDetails"
              :value.sync="formModel.requestData"
              :disabled="viewMode || !requiredData.isValidForEdit"
              validates="max:10000|allowed_special_character|required"
            ></naj-input>
          </v-col>
        </v-row>
      </div>
    </naj-box>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapState: mapGlobalState, mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');
import DynamicForm from '@/modules/global/components/dynamic-form/index';

export default {
  name: 'BankruptcyGeneralRequest',
  inject: ['$validator'],
  components: { DynamicForm },
  props: {
    formModel: {
      type: Object,
      default: () => ({}),
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return { requestDataJson: null };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    useDynamicForm() {
      return !!this.formModel.formId;
    },
  },
  watch: {},
  mounted() {
    // set json data for sub-requests with a dynamic form
    if (this.useDynamicForm) {
      this.requestDataJson = this.formModel.requestDataJson ? JSON.parse(this.formModel.requestDataJson) : {};
    }
  },
  methods: {
    ...mapGlobalActions(['getUserInfo']),
    dynamicFormChanged() {
      this.$set(this.formModel, 'requestDataJson', JSON.stringify(this.requestDataJson));
    },
  },
};
</script>

<style>
.requestAuditCenterNotes {
  color: rgb(236, 106, 79);
  caret-color: rgb(236, 106, 79);
}
</style>
